import React from "react";
import PageHero from "../components/shared/PageHero";
import PolicySection from "../components/legal/PolicySection";
import ContactPromptCard from "../components/legal/ContactPromptCard";

export default function Terms() {
  return (
    <>
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        subtitle="Questions about services, partnerships, or your account? Reach out and our team will get back to you."
      />

      <section className="mu-section pb-4">
        <div className="container">
          <PolicySection
            title="Terms & Conditions"
            paragraphs={[
              "By creating an account on MusicUntamed, you agree to use the platform to distribute, promote, and share music you own the rights to, and to follow the guidelines of every platform we distribute your music to.",
              "You keep 100% ownership of your masters and publishing at all times. MusicUntamed acts only as a distributor and service provider — we never claim ownership over the music you upload.",
              "Paid plans and one-time services are billed as described at checkout. You can cancel a recurring plan at any time; cancellation stops future billing but doesn't retroactively refund the current billing period.",
              "We may update these terms from time to time as the platform grows. We'll always aim to give you notice before any material change takes effect."
            ]}
          />

          <PolicySection
            title="Acceptable Use"
            paragraphs={[
              "You agree not to upload content that infringes on someone else's copyright, contains hate speech, or otherwise violates the law. Accounts found in violation may be suspended while we investigate.",
              "Playlist pitching, promotion, and PR services are best-effort — while we work hard to secure placements and coverage, no specific outcome is guaranteed by any plan or package."
            ]}
          />
        </div>
      </section>

      <ContactPromptCard />
    </>
  );
}
